import gql from 'graphql-tag';

export const GET_USER_TEAMS_QUERY = gql`
  query getTeams($organisationId: String!) {
    getTeams(organisationId: $organisationId) {
      teamId
      name
      imageUrl
    }
  }
`;

const getTeams = (organisationId) => ({
  query: GET_USER_TEAMS_QUERY,
  module: 'users',
  ignoreCache: true,
  buildVariables: () => ({ organisationId }),
  isSilent: true
});

export default getTeams;